'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstFileAttachmentIdInMessage = undefined;

var _fileAttachmentIdsInMessage = require('./fileAttachmentIdsInMessage');

/**
 *
 * @param {PubNubMessageRecord} message - pubnub message record
 * @returns {?number} first file attachment id in the message metadata
 *
 */
var firstFileAttachmentIdInMessage = exports.firstFileAttachmentIdInMessage = function firstFileAttachmentIdInMessage(message) {
  var fileAttachmentIds = (0, _fileAttachmentIdsInMessage.fileAttachmentIdsInMessage)(message);

  if (!fileAttachmentIds || !fileAttachmentIds.size) {
    return null;
  }

  return fileAttachmentIds.first();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/firstFileAttachmentIdInMessage.js
// module id = 1087
// module chunks = 2 3